import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Pagination } from "react-bootstrap";

const ExternalRepairItem = ({
  tickets,
  onEdit,
  onDelete,
  onExport,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  goToPage,
  isStart,
  isEnd,
  getNext,
  getPrev,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDate = (date) => {
    if (date != undefined) {
      try {
        var datetime = new Date(date.toDate()).toLocaleDateString("th-TH");
        return datetime;
      } catch {
        var newDate = new Date(date);
        return newDate.toLocaleDateString("th-TH");
      }
    } else {
      return "-";
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const getStatusVariant = (status) => {
    if (status === "อยู่ระหว่างดำเนินการ") {
      return "warning light";
    } else if (status === "เสร็จสิ้น") {
      return "success light";
    } else if (status === "ยกเลิก") {
      return "danger light";
    }
    return "secondary";
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>ER No.</th>
                      <th>Service Order</th>
                      <th>HN</th>
                      <th>Customer</th>
                      <th>Equipment</th>
                      <th>SN</th>
                      <th>Vendor</th>
                      <th>Sent Date</th>
                      <th>Repair Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="external-repair-table">
                    {!loading ? (
                      tickets.map((item, index) => {
                        const repairStatus =
                          (item.externalRepair && item.externalRepair.repairStatus) || "-";
                        const variantActivity = getStatusVariant(repairStatus);

                        return (
                          <tr key={item.id} className="btn-reveal-trigger">
                            <td className="py-2">
                              {index + 1 + (currentPage - 1) * itemsPerPage}
                            </td>
                            <td className="py-2">
                              {(item.externalRepair && item.externalRepair.externalRepairNo) || "-"}
                            </td>
                            <td className="py-2">{item.serviceOrderNumber}</td>
                            <td className="py-2">
                              <Link
                                to={"/patient-page/" + item.hn}
                                data-toggle="tooltip"
                                data-placement="top"
                                title={item.hn}
                              >
                                {item.hn}
                              </Link>
                            </td>
                            <td className="py-2">
                              {item.firstname} {item.lastname}
                            </td>
                            <td className="py-2">
                              {item.brand} {item.model}
                            </td>
                            <td className="py-2">{item.sn}</td>
                            <td className="py-2">
                              {(item.externalRepair && item.externalRepair.vendor) || "-"}
                            </td>
                            <td className="py-2">
                              {handleDate(item.externalRepair && item.externalRepair.sentDate)}
                            </td>
                            <td className="py-2">
                              <Badge variant={variantActivity}>
                                {repairStatus}
                              </Badge>
                            </td>
                            <td className="py-2 text-right">
                              <div className="d-flex">
                                <Link
                                  className="btn btn-primary shadow btn-xs sharp mr-2"
                                  to="#"
                                  onClick={() => onExport(item.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Export PDF"
                                >
                                  <i className="fa fa-file-pdf-o"></i>
                                </Link>
                                <Link
                                  className="btn btn-info shadow btn-xs sharp mr-2"
                                  to="#"
                                  onClick={() => onEdit(item.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Edit external repair"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  className="btn btn-danger shadow btn-xs sharp"
                                  to="#"
                                  onClick={() => onDelete(item.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Delete external repair"
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="11" className="text-center">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden"></span>
                          </div>
                        </td>
                      </tr>
                    )}
                    {!loading && tickets.length === 0 && (
                      <tr>
                        <td colSpan="11" className="text-center">
                          No external repairs found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {totalItems < currentPage * itemsPerPage
                    ? totalItems
                    : currentPage * itemsPerPage}{" "}
                  of {totalItems} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <Pagination
                    className="pagination-primary pagination-circle"
                    size="lg"
                  >
                    <Pagination.Prev onClick={getPrev} disabled={isStart} />
                    {pageNumbers.map((number) => (
                      <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => goToPage(number)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={getNext} disabled={isEnd} />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ExternalRepairItem;
